import { MarcacaoPK } from "../marcacao/marcacao-procedimento/pks/marcacao-pk";
import { InformacaoFechamentoMarcacaoDTO } from "./informacao-fechamento-marcacao-dto";

export class InformacaoFechamentoMarcacaoProcedimentoDTO extends InformacaoFechamentoMarcacaoDTO {

    pkMarcacao: MarcacaoPK | undefined;

}
